export enum DeliveryPricingRouteType {
  OfficeToOffice = 1,
  OfficeToAddress = 2,
  AddressToOffice = 3,
  AddressToAddress = 4
}

export interface IDeliveryPricing {
  id: number
  routeType: DeliveryPricingRouteType
  maxWeightKg: number
  priceEur: number
  effectiveFromDate: string
}
